export const FIRM_NAME = "Clear Horizon Consulting";
export const FIRM_SHORT = "CH";
export const FIRM_TAGLINE = "Clarity today. Impact tomorrow.";
export const FIRM_LOCATION = "Khalda, Amman, Jordan";

export const VISION_HERO =
  "To redefine how businesses in Jordan operate — structured, compliant, and built to scale.";

export const VISION_ABOUT =
  "To be the trusted partner behind well-built businesses; redefining how companies are structured, launched, strengthened and scaled.";

export const MISSION_ABOUT =
  "We build complete business foundations — legal, operational, financial, and strategic — that empower organizations to launch effectively, operate efficiently, and scale with confidence.";

export const MISSION_CTA =
  "We build businesses that are in control — of their structure, their numbers, and their future.";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1504802318913-d3f9a487448c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMG1pbmltYWxpc3QlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fGJsYWNrfDE3ODUzNDg0MzN8MA&ixlib=rb-4.1.0&q=85",
  pillar1: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG1pbmltYWxpc3QlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fGJsYWNrfDE3ODUzNDg0MzN8MA&ixlib=rb-4.1.0&q=85",
  pillar2: "https://images.unsplash.com/photo-1554793000-245d3a3c2a51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnl8ZW58MHx8fHwxNzg1MzQ4NDMzfDA&ixlib=rb-4.1.0&q=85",
  gold: "https://images.unsplash.com/photo-1656055450481-e47bc720e687?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxzdWJ0bGUlMjBnb2xkJTIwYWJzdHJhY3QlMjB0ZXh0dXJlfGVufDB8fHx5ZWxsb3d8MTc4NTM0ODQzM3ww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    number: "01",
    slug: "organizational-development",
    title: "Organizational Development & Management Systems",
    tagline: "Building the operating backbone of the organization.",
    team: "Founder-led core — industrial engineers.",
    description:
      "Manuals, policies, ISO/IMS, org design, HR & OD, logo & identity — the systems that make a company run.",
    items: [
      "Manuals (SOPs, templates & forms) and policies — develop, update & review",
      "IMS support & ISO readiness — 9001, 14001, 45001",
      "Internal audit support & certification readiness",
      "Organizational structures, job descriptions & HR forms",
      "Process mapping & workflow design",
      "Performance management systems",
      "Training needs assessment & tailored programs",
      "Document, folder & filing system design",
      "Vision, mission & values development",
      "Logo & visual identity, company profile",
    ],
    image: IMAGES.pillar1,
  },
  {
    number: "02",
    slug: "legal-compliance",
    title: "Legal & Compliance",
    tagline: "Establish, operate, and stay aligned with every requirement.",
    team: "Retained legal counsel.",
    description:
      "Company setup, contracts, corporate legal studies, legal operations, and regulatory compliance.",
    items: [
      "Company establishment & structuring support",
      "Legal policies & procedures — develop, review & update",
      "In-house legal advisory & corporate legal matters",
      "Contract review & drafting, contract lifecycle",
      "Corporate legal studies",
      "Personnel & HR legal matters",
      "Companies Control Department submissions & registration",
      "Legal awareness & induction sessions",
      "Regulatory alignment — including Jordan's PDPL (No. 24 of 2023)",
    ],
    image: IMAGES.pillar2,
  },
  {
    number: "03",
    slug: "financial-structuring",
    title: "Financial & Accounting Services",
    tagline: "From advisory and structuring to statutory compliance.",
    team: "Specialist finance lead.",
    description:
      "Advisory and structuring plus hands-on accounting, tax, and statutory compliance.",
    items: [
      "Financial & tax advisory",
      "Financial planning & analysis (FP&A)",
      "Budgeting, forecasting & cash-flow projections",
      "Cost control & cost-structure setup",
      "Internal control & internal audit",
      "Feasibility studies & business valuation",
      "Bookkeeping & financial statements",
      "Tax returns — preparation, filing & defense",
      "Company & Social Security registration, statutory filings",
      "Debt collection",
    ],
    image: IMAGES.gold,
  },
];

export const PACKAGES = [
  {
    number: "01",
    name: "Startup Foundation",
    target: "Founders & startups",
    features: [
      "Company formation & statutory registration",
      "Core HR, admin & finance policies",
      "Org structure + job descriptions",
      "Simple bookkeeping & financial setup",
      "Brand coordination via partners",
    ],
  },
  {
    number: "02",
    name: "Growing SME",
    target: "Growing small & mid-size firms",
    features: [
      "Full policies, SOPs & process mapping",
      "Org structure, JDs & performance system",
      "Legal & contract templates",
      "Budgeting & basic financial analysis",
      "Internal controls",
    ],
  },
  {
    number: "03",
    name: "Established Company",
    target: "Companies scaling & professionalizing",
    features: [
      "IMS / ISO readiness — 9001, 14001, 45001",
      "Regulatory & PDPL compliance",
      "Tax & statutory compliance",
      "Financial reporting & analysis",
      "Corporate legal studies",
    ],
  },
  {
    number: "04",
    name: "Group / Enterprise",
    target: "Groups & large organizations",
    features: [
      "Governance framework & Delegation of Authority",
      "Legal & advanced financial structuring",
      "Cash-flow, forecasting, risk & compliance",
      "Company & business valuation",
      "Consolidated financial support",
    ],
  },
];

export const HEALTH_CHECK = {
  name: "Business Health Check",
  description:
    "A focused review of your business across operations, legal, and finance — you leave with a clear picture of where you stand and what to fix first.",
  includes: ["Organizational review", "Legal compliance review", "Financial review", "Prioritized action summary"],
};

export const RETAINERS = [
  {
    slug: "internal-audit",
    name: "Internal Audit Outsourcing",
    description: "Ongoing internal audit coverage so your controls stay sharp between certifications.",
  },
  {
    slug: "legal-advisory",
    name: "Legal Advisory",
    description: "On-call legal counsel for contracts, policies, and day-to-day compliance.",
  },
  {
    slug: "hr-od-support",
    name: "HR & OD Support",
    description: "Continuous organizational development, HR frameworks, and people operations support.",
  },
  {
    slug: "part-time-cfo",
    name: "Financial Advisory / Part-Time CFO",
    description: "Senior financial oversight — reporting, cash flow, and structuring on a monthly rhythm.",
  },
  {
    slug: "combined",
    name: "Combined Support",
    description: "OD + Legal + Finance in one integrated retainer — your full back-office team.",
    featured: true,
  },
];

export const INTEREST_OPTIONS = [
  "General Consultation",
  "Business Health Check",
  "Startup Foundation",
  "Growing SME",
  "Established Company",
  "Group / Enterprise",
  "Monthly Retainer",
];

export const VALUES = [
  { number: "01", title: "Integrity", text: "Honesty, transparency, and professional ethics in every engagement." },
  { number: "02", title: "Practicality", text: "Realistic, implementable solutions tailored to real business environments." },
  { number: "03", title: "Accountability", text: "An ownership mindset — we stand behind measurable outcomes." },
  { number: "04", title: "Excellence", text: "High standards in quality, consistency, and attention to detail." },
  { number: "05", title: "Client Commitment", text: "We understand client needs deeply and deliver real business impact." },
  { number: "06", title: "Integration", text: "Operational, legal, financial, and risk expertise in one aligned solution." },
];

export const METHODOLOGY = [
  { number: "01", title: "Discover & Gather", text: "Free initial consultation, stakeholder interviews, and document & data gathering — operational, legal & financial — to map the current state." },
  { number: "02", title: "Analyze & Diagnose", text: "Gap analysis against standards, regulations & best practice — from process gaps to legal exposure and financial-control weaknesses." },
  { number: "03", title: "Design & Map", text: "We build structures, policies, contracts & financial models — and map every process as a clear flowchart." },
  { number: "04", title: "Implement & Enable", text: "Roll-out via a shared workspace — registrations, filings, training and a full handover." },
  { number: "05", title: "Review & Refine", text: "Collaborative review rounds until every deliverable fits — no guesswork, no loose ends." },
];

export const DELIVERABLES = [
  "Gap analysis",
  "Visio process maps",
  "Manuals, SOPs & policies",
  "Contracts & compliance",
  "Financial models & statements",
  "Shared SharePoint workspace",
];

export const ADVANTAGES = [
  { title: "Practical Expertise", text: "Professional knowledge combined with hands-on corporate experience." },
  { title: "End-to-End Financial Strength", text: "From company setup and statutory compliance to financial management, tax advisory, internal control, and strategic planning — in one place." },
  { title: "We Solve the Real Pain Points", text: "We dig deep into your operational and financial pain points — and fix them, not just document them." },
  { title: "Flexible & Adaptive", text: "We flex to how you work — scope, pace, and delivery shaped around your business." },
  { title: "Integrated Thinking", text: "Organizational, legal and financial perspectives brought together when the challenge requires it." },
  { title: "Standards Fluency", text: "We prepare clients for IMS certification — ISO 9001, 14001 & 45001 — and track evolving standards like ISO 9001:2026." },
];

export const CONTACT = {
  email: "info@clearhorizon-consulting.com",
  phone: "+962 79 757 4143",
  phoneHref: "tel:+962797574143",
  instagram: "https://www.instagram.com/ch.consulting.co",
  instagramHandle: "@ch.consulting.co",
};

export const MARQUEE_WORDS = ["Structure", "Compliance", "Governance", "Scale", "Clarity", "Control"];
